import setCurrentPage from "src/Utils/setCurrentPage";
import ConversationEffect from "src/Animations/ConversationEffect";
import setPreviousPage from "src/Utils/setPreviousPage";
import ButtonsGroupPanel from "src/Components/Common/ButtonsGroupPanel";
import EntryEffect from "src/Animations/EntryEffect";

const PANEL_BUTTONS_DATA = [
  {
    label: "COST OBSERVALIBILITY",
    onClick: () => {
      setPreviousPage(111);
      setCurrentPage(112);
    },
    endIcon: "arrow-right",
    type: "panel-enabled" as ButtonProps["type"],
  },
  {
    label: "cost optimization",
    onClick: () => {
      setPreviousPage(111);
      setCurrentPage(113);
    },
    endIcon: "arrow-right",
    type: "panel-enabled" as ButtonProps["type"],
  },
  {
    label: "Cognitive finops",
    onClick: () => {
      setPreviousPage(111);
      setCurrentPage(114);
    },
    endIcon: "arrow-right",
    type: "panel-enabled" as ButtonProps["type"],
  },
];

export const DATA_DOW_DEMO_DNA1_7 = {
  title: `Tony uses the <span style="color: #92D1FF;">Cost Management module \n</span>function to monitor costs across the \nentire landscape.`,
  subtitle: "Data Operations Workbench demo",
  label: [{ iconPath: "start.png", text: "Cost Management" }],
  next: {
    label: "END DEMO",
    onClick: () => {
      setPreviousPage(111);
      setCurrentPage(115);
    },
    type: "transparent" as "transparent",
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(110),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <ConversationEffect
        images={[
          {
            image: "DNA1/DNA1_DOW_DEMO_07_Computer.png",
            imageStyle: {
              position: "absolute",
              right: "193.67px",
              bottom: "235.58px",
            },
            effect: "animate-opacity",
          },
          {
            image: "DNA1/DNA1_DOW_DEMO_07_PopUp_1.png",
            imageStyle: {
              position: "absolute",
              right: "100.09px",
              bottom: "424px",
            },
          },
          {
            image: "DNA1/DNA1_DOW_DEMO_07_PopUp_2.png",
            imageStyle: {
              position: "absolute",
              right: "527px",
              bottom: "275px",
            },
          },
          {
            image: "DNA1/DNA1_DOW_DEMO_07_PopUp_3.png",
            imageStyle: {
              position: "absolute",
              right: "421px",
              bottom: "278px",
            },
          },
        ]}
        pageNumber={111}
      />
      <EntryEffect
        pageNumber={111}
        entryDelay={2750}
        entryStyle={{ position: "absolute", bottom: "96px", right: "100px" }}
      >
        <ButtonsGroupPanel
          title={"SELECT A FEATURE"}
          panelButtons={PANEL_BUTTONS_DATA}
        />
      </EntryEffect>
    </div>
  ),
};
